module.exports = __webpack_public_path__ + "img/kryptos-logo.994fb892.png";